// extracted by mini-css-extract-plugin
export var authorByLineTooltipTrigger = "bB_fG";
export var authorBylineContainer = "bB_fD";
export var authorPrefix = "bB_fF";